import { render, staticRenderFns } from "./NetaAttractionBasicDataComponent.vue?vue&type=template&id=ad63a1a8&scoped=true&"
import script from "./NetaAttractionBasicDataComponent.vue?vue&type=script&lang=js&"
export * from "./NetaAttractionBasicDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaAttractionBasicDataComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NetaAttractionBasicDataComponent.vue?vue&type=style&index=1&id=ad63a1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad63a1a8",
  null
  
)

export default component.exports